import { Dayjs } from 'dayjs';

export function checkDayIsIncluded(days: Dayjs[], day: Dayjs) {
  return days.some((x) => x.isSame(day, 'day'));
}
